<template>
    <loPage>
        <loSection>
            <loHeading></loHeading>
            <loArticle>
                <mdCartCaption
                    :caption="$t('page.title.commoditypricing')"
                >
                    <div class="func">
                        <cpBtn
                            themes="info"
                            icon="arrow_back"
                            @click.prevent="goBack"
                        >{{ $t('site.func.previouspage') }}</cpBtn>
                    </div>
                </mdCartCaption>
                <mdSearch>
                    <cpCombobox
                        :nullString="$t('site.label.search.all')"
                        :label="$t('site.label.filter')"
                        :options="type_list"
                        v-model="type"
                        @change="confirmProduct"
                    ></cpCombobox>
                    <cpCombobox
                        :nullString="$t('site.label.search.all')"
                        :label="$t('site.label.filter.commodity')"
                        :options="product_list"
                        v-model="product"
                    ></cpCombobox>
                    <cpBtn
                        icon="search"
                        :title="$t('site.noun.search')"
                        @click.prevent="doSearch"
                    ></cpBtn>
                </mdSearch>
                <div class="g show-data-list">
                    <ul><li
                        v-for="item in showData"
                        :key="item.sn"
                    >
                        <div class="g card-area">
                            <mdCaption
                                v-if="item.area_cht === '－'"
                                :caption="item.product_cht"
                            ></mdCaption>
                            <mdCaption
                                v-else
                                :caption="item.product !== item.product_cht? item.product: item.product +' '+ item.product_cht"
                            ></mdCaption>
                            <div class="g border-info-area">
                                <div class="g border-info">
                                    <span v-if="item.area_cht !== '－'" class="info-label-01">{{ item.area_cht }}</span>
                                </div>
                                <div class="g border-info">
                                    <span v-if="item.area_cht !== '－'" class="info-label-02">{{ item.timestamp +' '+ item.datasource +' ('+ item.cycle_cht +')' }}</span>
                                </div>
                            </div>
                            <div class="g border-chart">
                                <div class="md order-chart-icon is-right">
                                    <cpLabel
                                        :themes="item.increase === 0? 'minor': item.increase > 0? 'danger': 'success'"
                                        :icon="item.increase === 0? 'remove': item.increase > 0? 'arrow_drop_up': 'arrow_drop_down'"
                                        :text="Math.abs(item.increase)"
                                    ></cpLabel>
                                </div>
                                <mdChart
                                    :obj="item.chart"
                                    :height="200"
                                ></mdChart>
                            </div>
                            <div class="g board-list">
                                <div class="g board-item">
                                    <mdItemInfo
                                        :caption="`<span class='icon-font upload'>${$t('page.commodity.caption.high')}</span>`"
                                        size="s"
                                        :value="item.interval.up"
                                        :int="1"
                                    ></mdItemInfo>
                                </div>
                                <div class="g board-item">
                                    <mdItemInfo
                                        :caption="`<span class='icon-font attach_mone'>${$t('page.commodity.caption.last')}</span>`"
                                        size="s"
                                        :value="item.close_price"
                                        :int="1"
                                    ></mdItemInfo>
                                </div>
                                <div class="g board-item">
                                    <mdItemInfo
                                        :caption="`<span class='icon-font download'>${$t('page.commodity.caption.low')}</span>`"
                                        size="s"
                                        :value="item.interval.down"
                                        :int="1"
                                    ></mdItemInfo>
                                </div>
                            </div>
                        </div>
                    </li></ul>
                </div>
            </loArticle>
        </loSection>
    </loPage>
</template>

<script>
    import loPage from '@/components/loPage'
    import loSection from '@/components/loSection'
    import loHeading from '@/components/loHeading'
    import loArticle from '@/components/loArticle'
    import gCard from '@/components/gCard'
    import mdSearch from '@/components/mdSearch'
    import mdCartCaption from '@/components/mdCartCaption'
    import mdItemInfo from '@/components/mdItemInfo'
    import mdChart from '@/components/mdChart'
    import mdCaption from '@/components/mdCaption'
    import cpCombobox from '@/components/cpCombobox'
    import cpBtn from '@/components/cpBtn'
    import cpLabel from '@/components/cpLabel'

    import { mapState, mapMutations } from 'vuex'

    export default {
        components: {
            loPage,
            loSection,
            loHeading,
            loArticle,
            gCard,
            mdSearch,
            mdCartCaption,
            mdItemInfo,
            mdChart,
            mdCaption,
            cpCombobox,
            cpBtn,
            cpLabel,
        },
        data: function(){

            return {
                type: '',
                product: '',
                listClass: [],
                showData: [],
            }
        },
        computed: {
            ...mapState([
                'user'
            ]),
            type_list: function(){
                let $listClass = this.listClass;
                
                let $result = {}

                $listClass.forEach(item => {
                    $result[item.type] = item.type_cht;
                });

                return $result
            },
            product_list: function(){
                let _type = this.type,
                    $listClass = this.listClass;
                
                let $result = {}

                let  $_add = (type, product) => {
                        $result[type.type +'___'+ product.product] = product.product_cht +' ('+ type.type_cht +')';
                    }

                if( _type ) {
                    let $type = _type.split(',');

                    $type.forEach(_type => {
                        let $target = $listClass.find(item => {
                                return item.type === _type;
                            });

                        if( $target ) {

                            $target.productItem.forEach(item => {
                                $_add($target, item);
                            });
                        }
                    });

                }else {

                    $listClass.forEach(item => {

                        item.productItem.forEach($item => {
                            $_add(item, $item);
                        });
                    });
                }

                return $result;
            },
        },
        methods: {
            ...mapMutations([
                'catchError',
                'clearPopUp',
                'pushPopUp',
            ]),
            goBack: function(){
                this.$router.go(-1);
            },
            doSearch: async function(){

                try {
                    let $data = await this.getData();

                    if( this.type ) {
                        localStorage.setItem('materialPriceType', this.type); //紀錄瀏覽大類
                    }else {
                        localStorage.removeItem('materialPriceType');
                    }

                    if( this.product ) {
                        localStorage.setItem('materialPriceProduct', this.product); //紀錄瀏覽品項
                    }else {
                        localStorage.removeItem('materialPriceProduct');
                    }

                    let $showData = this.initData($data, 'list');

                    this.$set(this, 'showData', $showData);

                }catch(error) {

                    this.catchError({
                        error: error,
                        callback: this.doSearch,
                    });
                }
            },
            confirmProduct: function() {
                let _type = this.type;

                if( _type ) {

                    let $type = _type.split(','),
                        _product = this.product,
                        $product = _product.split(',');

                    let $_match = (product) => {
                            let __type = product.replace(/___(.*)+/, '')

                            return $type.includes(__type)
                        }

                    let $result = $product.filter(product => $_match(product));

                    this.$set(this, 'product', $result.join(','))
                }
            },
            getTime: function(timestamp){
                return timestamp.replace(/\T(.*)+/, '');
            },
            getChart: function(arr, mode){
                let $labels = [],
                    $data = [];

                let $options = {
                        legend: {
                            display: false,
                        },
                        responsive: true,
                        maintainAspectRatio: false,
                        lineTension: 1,
                    }

                let _interval = this.getIncrease(arr),
                    _color = '';

                if( _interval > 0 ) {
                    _color = '#ff676c';
                }else if( _interval == 0 ) {
                    _color = '#aaaaaa';
                }else if( _interval < 0 ) {
                    _color = '#00a267';
                }

                let $datasets = [
                        {
                            borderColor: _color,
                            backgroundColor: 'rgba('+ this.$okaTool.hexToRgb(_color).join(',') +', .2)',
                            fill: true,
                            data: $data,
                            label: '歷史價格',
                        }
                    ]

                let $result = {
                        type: 'line',
                        data:{
                            datasets: $datasets,
                            labels: $labels,
                        },
                        options: $options
                    }

                arr.forEach(item => {
                    let _time = this.getTime(item.timestamp),
                        _price = item.close_price;

                    $labels.push(_time);
                    $data.push(_price);
                });

                if( mode === 'list' ) {

                    $datasets[0].pointRadius = 2;

                    $options.scales = {
                        yAxes: [
                            {
                                // display: false,
                                ticks: {
                                    padding: 15,
                                    beginAtZero: false,
                                },
                            }
                        ],
                        xAxes: [
                            {
                                display: false,
                            }
                        ]
                    }
                }else {

                    $options.scales = {
                        yAxes: [
                            {
                                scaleLabel: {
                                    display: true,
                                    // labelString: '價格(美金)' //他媽有可能突然某一個是人民幣
                                    labelString: '價格'
                                },
                                ticks: {
                                    padding: 10,
                                    callback: (num) => {
                                        return this.$okaTool.numberToStringFormat(num);
                                    }
                                }
                            }
                        ],
                        xAxes: [
                            {
                                scaleLabel: {
                                    display: true,
                                    labelString: '西元年/月'
                                },
                                ticks: {
                                    callback: (day) => {
                                        return day.replace(/(^\d{4})(\d{2}$)/, '$1/$2');
                                    }
                                }
                            }
                        ]
                    }
                }

                return $result;
            },
            getInterval: function(arr){
                let $result = {
                        up: -Infinity,
                        down: Infinity
                    }

                arr.forEach(item => {
                    let _price = item.close_price;

                    $result.up = Math.max($result.up, _price);
                    $result.down = Math.min($result.down, _price);
                });

                return $result;
            },
            getIncrease: function(arr){
                let _length = arr.length,
                    _base = 1000;

                let _result = 0;

                if( _length > 1 ) {

                    let _last_price = arr[_length - 1].close_price,
                        _last_2_price = arr[_length - 2].close_price;

                    _result = (_last_price * _base - _last_2_price * _base) / _base;
                }

                return _result;
            },
            getCondition: function(){
                let _product = this.product,
                    _type = this.type;

                let $ref = {},
                    $result = []

                if( _product ) {
                    let $product = _product.split(',');

                    $product.forEach(item => {
                        let $item = item.split('___'),
                            _type = $item[0],
                            _product = $item[1]

                        if( $ref[_type] ) {
                            $ref[_type].push(_product);
                        }else {
                            $ref[_type] = [_product];
                        }
                    });
                }else if( _type ) {
                    let $listClass = this.listClass,
                        $type = _type.split(',');

                    $type.forEach(item => {
                        let $target = $listClass.find($item => {
                                return $item.type === item;
                            });

                        if( $target ) {

                            let _type = $target.type,
                                $productItem = $target.productItem;

                            $ref[_type] = []

                            $productItem.forEach($item => {
                                $ref[_type].push($item.product);
                            });
                        }
                    });
                }else {
                    let $listClass = this.listClass;

                    $listClass.forEach(item => {
                        let _type = item.type,
                            $productItem = item.productItem;

                        $ref[_type] = []

                        $productItem.forEach($item => {
                            $ref[_type].push($item.product);
                        })
                    });
                }

                for( let _key in $ref ) {
                    
                    $result.push({
                        type: _key,
                        product: $ref[_key].join(',')
                    });
                }

                return $result
            },
            initData: function(data, chartType){
                let $ref = {},
                    $result = []

                data.forEach(item => {
                    let _type = item.type, //大類
                        _product = item.product, //品別
                        _area = item.area, //地區
                        _cycle = item.cycle, //週期
                        _datasource = item.datasource; //來源

                    if( _type && _product && _cycle && _datasource && _area ) {

                        if( !$ref[_type] ) { //大類
                            $ref[_type] = {}}

                        if( !$ref[_type][_product] ) { //品別
                            $ref[_type][_product] = {}
                        }

                        if( !$ref[_type][_product][_area] ) { //地區
                            $ref[_type][_product][_area] = {}
                        }

                        if( !$ref[_type][_product][_area][_cycle] ) { //週期
                            $ref[_type][_product][_area][_cycle] = {}
                        }

                        if( !$ref[_type][_product][_area][_cycle][_datasource] ) { //供應商
                            $ref[_type][_product][_area][_cycle][_datasource] = {
                                subs: []
                            }
                        }

                        $ref[_type][_product][_area][_cycle][_datasource].subs.push(item);
                    }
                });

                for( let _t in $ref ) { //大類
                    
                    for( let _p in $ref[_t] ) { //品別

                        for( let _a in $ref[_t][_p] ) { //地區

                            for( let _c in $ref[_t][_p][_a] ) { //週期

                                for( let _d in $ref[_t][_p][_a][_c] ) { //供應商

                                    let $target = $ref[_t][_p][_a][_c][_d],
                                        $arr = $target.subs;
                                
                                    $arr.sort((a, b) => {

                                        if( a.timestamp > b.timestamp ) {
                                            return 1;
                                        }else {
                                            return -1;
                                        }
                                    });

                                    let $node = $arr[$arr.length - 1],
                                        _key = $node.type +'-'+ $node.product +'-'+ $node.area +'-'+ $node.cycle +'-'+ $node.datasource;

                                    $arr.forEach((item, index) => {
                                        item.sn = _key +'-'+ index;
                                        item.timestamp = this.getTime(item.timestamp).replace(/\-/g, '/');
                                        item.show = true;
                                    });

                                    $target.data = {
                                        sn: _key,
                                        area: $node.area,
                                        area_cht: $node.area_cht,
                                        close_price: $node.close_price,
                                        cycle: $node.cycle,
                                        cycle_cht: $node.cycle_cht,
                                        datasource: $node.datasource,
                                        product: $node.product,
                                        product_cht: $node.product_cht,
                                        timestamp: this.getTime($node.timestamp).replace(/\-/g, '/'),
                                        type: $node.type,
                                        type_cht: $node.type_cht,
                                        interval: this.getInterval($arr),
                                        increase: this.getIncrease($arr),
                                        chart: this.getChart($arr, chartType),
                                        data: $arr,
                                    }
                                }
                            }
                        }
                    }
                }

                for( let _t in $ref ) {

                    for( let _p in $ref[_t] ) {
                    
                        for( let _a in $ref[_t][_p] ) { //地區

                            for( let _c in $ref[_t][_p][_a] ) { //週期

                                for( let _d in $ref[_t][_p][_a][_c] ) { //供應商
                                    $result.push($ref[_t][_p][_a][_c][_d].data);
                                }
                            }
                        }
                    }
                }

                return $result;
            },
            getData: function(){
                let _url = this.$siteTool.apiUrl({
                        class: 'MaterialMarket',
                        func: 'List',
                    });

                let $condition = this.getCondition();

                return this.$http.post(_url, $condition);
            },
            initClass: function(data) {
                this.$set(this, 'listClass', data);

                let _materialPriceType = localStorage.getItem('materialPriceType'),
                    _materialPriceProduct = localStorage.getItem('materialPriceProduct');
            
                if( _materialPriceType ) {
                    this.$set(this, 'type', _materialPriceType);

                    if( _materialPriceProduct ) {
                        this.$set(this, 'product', _materialPriceProduct);
                    }
                }

                this.doSearch();
            },
            getClass: function() {
                let _url = this.$siteTool.apiUrl({
                        class: 'MaterialList',
                        func: 'List',
                    });

                return this.$http.post(_url, []);
            },
            init: async function(){

                try {
                    let $response = await this.getClass();
                    
                    this.initClass($response);

                }catch(error) {

                    this.catchError({
                        error: error,
                        callback: this.init,
                    });
                }
            }
        },
        created: function(){
            this.init();
        }
    }
</script>

<style scoped lang="scss">

    .g.show-data-list {

        > ul {
            @extend %reset;

            > li {
                display: inline-block;
                vertical-align: top;
                width: (100% / 3);
                max-width: 500px;
                box-sizing: border-box;
                padding: $interval-s;

                @include media('center') {
                    width: (100% / 2);
                    max-width: none;
                }

                @include media('mobile') {
                    display: block;
                    width: auto;
                    max-width: none;
                }
            }
        }
    }

    .g.card-area {
        padding: $interval-l;
        background-color: $white;
        box-shadow: 0 0 $interval-s $light-gray;
    }

    .g.border-chart {
        position: relative;

        .md.order-chart-icon {
            position: absolute;
            top: 0;
            margin-top: 0;

            &.is-right {
                right: $interval-s;
            }

            &.is-left {
                left: 60px;
            }

            font-size: $font-size-xl;
            z-index: 1;
        }
    }

    .g.show-data-list {

        > ul {

            > li {

                > .g.card {
                    padding: $interval-m;
                }
            }
        }
    }

    .g.border-info-area {
        display: flow-root;

        .g.border-info {
            margin-top: 0;
            float: left;

            .info-label-01 {
                padding: $interval-xs $interval-s;
                background-color: $major-color;
                color: $white;
            }

            .info-label-02 {
                padding: $interval-xs $interval-s;
                background-color: $third-color;
                color: $major-color;
            }

            + .g.border-info {
                float: right;
            }
        }
    }
    
    .md.chart::v-deep {
        
        .proportion {

            @include media('mobile') {
                padding-bottom: 10%;
            }
        }
    }

    .g.board-list {
        display: flow-root;

        .g.board-item {
            float: left;
            width: (100% / 3);
            box-sizing: border-box;
            margin-top: 0;
            padding-left: $interval-s / 2;
            padding-right: $interval-s / 2;
            
            &:first-child {
                padding-left: 0;
            }
            
            &:last-child {
                padding-right: 0;
            }
        }
    }
</style>
 